"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _Text = _interopRequireDefault(require("../../../core/Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SecondaryMenuItem = ({
  icon,
  lightTheme,
  label,
  href,
  target
}) => {
  const theme = (0, _react2.useTheme)();
  const color = lightTheme ? theme.lightMenuExternalLinkColor : theme.defaultMenuExternalLinkColor;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    href: href,
    color: color,
    trackingEvent: 'Menu click: ' + label,
    trackingName: "Sidemenu",
    target: target,
    children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      color: color,
      size: "15px",
      children: label
    })]
  });
};
var _default = exports.default = SecondaryMenuItem;